export const masterImportConfigs = {
  drivers: {
    key: "drivers",
    label: "Drivers",
    description: "Bring in driver rosters with license, expiry, and status details.",
    templatePath: "/driver-import-template.csv",
  },
  customers: {
    key: "customers",
    label: "Customers",
    description: "Import customer billing records with contact and payment defaults.",
    templatePath: "/customer-import-template.csv",
  },
  trucks: {
    key: "trucks",
    label: "Trucks",
    description: "Load truck units with plate, VIN, make, and current fleet status.",
    templatePath: "/truck-import-template.csv",
  },
  trailers: {
    key: "trailers",
    label: "Trailers",
    description: "Load trailer inventory with type, plate, and maintenance status.",
    templatePath: "/trailer-import-template.csv",
  },
  locations: {
    key: "locations",
    label: "Locations",
    description: "Seed saved pickup and delivery locations for repeat planning.",
    templatePath: "/location-import-template.csv",
  },
};